/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Tabs_ReviewsInputs */

const he_account_tabs_reviews = /** @type {(inputs: Account_Tabs_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ביקורות`)
};

const en_account_tabs_reviews = /** @type {(inputs: Account_Tabs_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviews`)
};

/**
* | output |
* | --- |
* | "Reviews" |
*
* @param {Account_Tabs_ReviewsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_tabs_reviews = /** @type {((inputs?: Account_Tabs_ReviewsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Tabs_ReviewsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_tabs_reviews(inputs)
	return en_account_tabs_reviews(inputs)
});